import React, { Component } from "react";
import PropTypes from "prop-types";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import Toggle from "material-ui/Toggle";
import { DivHeaderActions, DivTitle } from "./styled";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { UploadImageArray } from "../../../components";
import { TextInput, Counter } from "./components";

class CarouselView extends Component {
  constructor(props) {
    super(props);
    const { imageUrl, altText, auto, interval, direction } = props.data.values;
    this.state = {
      isEditMode: false,
      expanded: true,
      expandedImageMobile: false,
      expandedImageDesktop: false,
      imageDesktop: imageUrl.url,
      imageMobile: imageUrl.urlMobile,
      altText: altText,
      direction: direction,
      auto: auto,
      interval: interval
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  handleExpandIMChange = expanded => {
    this.setState({ expandedImageMobile: expanded });
  };
  handleExpandIDChange = expanded => {
    this.setState({ expandedImageDesktop: expanded });
  };

  onChangeDirection = (event, value) => {
    this.setState({ direction: value });
  };
  onUpdateUrlDesktop = value => {
    this.setState({ imageDesktop: value });
  };
  onUpdateUrlMobile = value => {
    this.setState({ imageMobile: value });
  };
  onUpdateAltText = value => {
    this.setState({ altText: value });
  };
  onToggle = (e, v) => {
    this.setState({ auto: v });
  };
  onUpdateInterval = value => {
    this.setState({ interval: value });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    let imageUrl = {
      url: this.state.imageDesktop,
      urlMobile: this.state.imageMobile
    };
    newData.values.altText = this.state.altText;
    newData.values.imageUrl = imageUrl;
    newData.values.auto = this.state.auto;
    newData.values.direction = this.state.direction;
    newData.values.interval = this.state.interval;
    localStorage.setItem("CarouselView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const imageContent = JSON.parse(localStorage.getItem("CarouselView"));
    if (imageContent) {
      const { imageUrl, altText, auto, direction, interval } = imageContent;
      this.setState({
        imageDesktop: imageUrl.url,
        imageMobile: imageUrl.urlMobile,
        altText: altText,
        auto,
        direction,
        interval
      });
    }
  };
  onClickSave = () => {
    let newData = this.props.data;
    let imageUrl = {
      url: this.state.imageDesktop,
      urlMobile: this.state.imageMobile
    };
    newData.values.altText = this.state.altText;
    newData.values.imageUrl = imageUrl;
    newData.values.auto = this.state.auto;
    newData.values.direction = this.state.direction;
    newData.values.interval = this.state.interval;
    this.props.onUpdateData(newData);
  };

  render() {
    // const {type} = this.props.data.values;
    return (
      <div style={{ width: "100%" }}>
        <div style={{ overflowY: "scroll", height: 500 }}>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expandedImageDesktop}
              onExpandChange={this.handleExpandIDChange}
            >
              <CardHeader
                title="Image Carousel"
                subtitle="Content of Desktop"
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Paper style={styles.paperText} zDepth={1}>
                  <UploadImageArray
                    type="desktop"
                    imageUrl={this.state.imageDesktop}
                    onUpdateUrl={value => this.onUpdateUrlDesktop(value)}
                    title="Desktop"
                  />
                </Paper>
              </CardText>
            </Card>
          </div>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expandedImageMobile}
              onExpandChange={this.handleExpandIMChange}
            >
              <CardHeader
                title="Image Carousel"
                subtitle="Content of Mobile"
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Paper style={styles.paperText} zDepth={1}>
                  <UploadImageArray
                    type="mobile"
                    imageUrl={this.state.imageMobile}
                    onUpdateUrl={value => this.onUpdateUrlMobile(value)}
                    title="Mobile"
                  />
                </Paper>
              </CardText>
            </Card>
          </div>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expanded}
              onExpandChange={this.handleExpandChange}
            >
              <CardHeader
                title="General"
                subtitle="Content Carousel"
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Alternatif Text</DivTitle>
                  <TextInput
                    value={this.state.altText}
                    onChange={value => this.onUpdateAltText(value)}
                    title=""
                  />
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Direction</DivTitle>
                  <RadioButtonGroup
                    name="direction"
                    valueSelected={this.state.direction}
                    onChange={this.onChangeDirection}
                    style={styles.radioGroup}
                  >
                    <RadioButton
                      value="incremental"
                      label="Incremental"
                      style={styles.radioButton}
                    />
                    <RadioButton
                      value="decremental"
                      label="Decremental"
                      style={styles.radioButton}
                    />
                  </RadioButtonGroup>
                  <Toggle
                    label="Auto Play"
                    style={{ marginBottom: 10, marginTop: 10, width: 180 }}
                    toggled={this.state.auto}
                    onToggle={(e, v) => this.onToggle(e, v)}
                  />
                  <Counter
                    isDisabled={false}
                    title="Interval"
                    onSetValue={value => this.onUpdateInterval(value)}
                    value={this.state.interval}
                    interval={1}
                    subtitle="second"
                    minValue={0}
                  />
                </Paper>
              </CardText>
            </Card>
          </div>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 136
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

CarouselView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

CarouselView.defaultProps = {
  data: {}
};
export default CarouselView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/CarouselView.js